import React from "react";
import { TransparentImage } from "./BrandLogo";

export const CERT_LOGO_A = "https://customer-assets.emergentagent.com/job_pilgrimage-journey-2/artifacts/ey75dvjh_logo%20A.png";
export const CERT_LOGO_KAN = "https://customer-assets.emergentagent.com/job_pilgrimage-journey-2/artifacts/civmohne_logo%20KAN.png";
export const CERT_LOGO_PPIU = "https://customer-assets.emergentagent.com/job_pilgrimage-journey-2/artifacts/5gshsi7k_logo%20PPIU.png";

const CERTS = [
  { src: CERT_LOGO_PPIU, alt: "PPIU Certified — Ekualindo Certification" },
  { src: CERT_LOGO_KAN, alt: "KAN — Komite Akreditasi Nasional" },
  { src: CERT_LOGO_A, alt: "Akreditasi A — Travel Umrah" },
];

export default function CertBadges({ variant = "auto", className = "", size = "h-14" }) {
  return (
    <div className={`flex items-center gap-6 flex-wrap ${className}`} data-testid="cert-badges">
      {CERTS.map((c) => (
        <TransparentImage
          key={c.src}
          src={c.src}
          alt={c.alt}
          variant={variant}
          className={`${size} w-auto opacity-90 hover:opacity-100 transition-opacity`}
        />
      ))}
    </div>
  );
}
